export var numeralform;
(function (numeralform) {
    numeralform[numeralform["definite"] = 0] = "definite";
    numeralform[numeralform["indefinite"] = 1] = "indefinite";
    numeralform[numeralform["ordinal"] = 2] = "ordinal";
})(numeralform || (numeralform = {}));
;
export const numeral = (n, f = numeralform.indefinite) => {
    var _a;
    return (_a = {
        0: f == numeralform.ordinal ? 'nullte' : 'null',
        1: f == numeralform.ordinal ? 'første' : (f === numeralform.indefinite ? 'én' : 'ett'),
        2: f == numeralform.ordinal ? 'andre' : 'to',
        3: f == numeralform.ordinal ? 'tredje' : 'tre',
        4: f == numeralform.ordinal ? 'fjerde' : 'fire',
        5: f == numeralform.ordinal ? 'femte' : 'fem',
        6: f == numeralform.ordinal ? 'sjette' : 'seks',
        7: f == numeralform.ordinal ? 'sjuende' : 'sju',
        8: f == numeralform.ordinal ? 'åttende' : 'åtte',
        9: f == numeralform.ordinal ? 'niende' : 'ni',
        10: f == numeralform.ordinal ? 'tiende' : 'ti'
    }[n]) !== null && _a !== void 0 ? _a : (numeralform.ordinal ? `${n}.` : `${n}`);
};
